import { apiClient } from '@features/shared/api/client'
import type { SidebarFavoritesResponse } from './contracts'

const FAVORITES_PATH = '/users/me/sidebar/favorites'

/** GET /users/me/sidebar/favorites: the user's favorites, in their own order. */
export async function getFavorites(): Promise<SidebarFavoritesResponse> {
  const { data } = await apiClient.get<SidebarFavoritesResponse>(FAVORITES_PATH)
  return data
}

/** POST /users/me/sidebar/favorites: adds a page at the end. */
export async function addFavorite(path: string): Promise<SidebarFavoritesResponse> {
  const { data } = await apiClient.post<SidebarFavoritesResponse>(FAVORITES_PATH, { path })
  return data
}

/** DELETE /users/me/sidebar/favorites?path=: takes a page out. */
export async function removeFavorite(path: string): Promise<SidebarFavoritesResponse> {
  const { data } = await apiClient.delete<SidebarFavoritesResponse>(FAVORITES_PATH, {
    params: { path },
  })
  return data
}

/** PUT /users/me/sidebar/favorites/order: the Custom order. */
export async function reorderFavorites(paths: string[]): Promise<SidebarFavoritesResponse> {
  const { data } = await apiClient.put<SidebarFavoritesResponse>(`${FAVORITES_PATH}/order`, {
    paths,
  })
  return data
}

/** PUT /users/me/sidebar/favorites/last-opened: stamps favorites just opened, for Recency. */
export async function recordFavoritesOpened(paths: string[]): Promise<SidebarFavoritesResponse> {
  const { data } = await apiClient.put<SidebarFavoritesResponse>(`${FAVORITES_PATH}/last-opened`, {
    paths,
  })
  return data
}
